import { SxProps, Typography, TypographyProps } from '@mui/material';
import { Theme } from '@mui/material/styles';
import * as React from 'react';

import { TypographyClamped } from '@/components/typography/TypographyClamped';
import { COLORS } from '@/styles/tokens/colors';

interface HeaderCellTypographyProps {
  sx?: SxProps<Theme>;
  clampLines?: boolean;
  variant?: TypographyProps['variant'];
}

export function HeaderCellTypography({
  sx,
  children,
  clampLines = false,
  variant = 'body-xs',
}: React.PropsWithChildren<HeaderCellTypographyProps>) {
  const sharedProps: TypographyProps = {
    component: 'p',
    sx: {
      whiteSpace: 'normal',
      ...sx,
    },
    color: COLORS.TEXT.SECONDARY,
  };

  if (clampLines) {
    return (
      <TypographyClamped lines={3} variant={variant} {...sharedProps}>
        {children}
      </TypographyClamped>
    );
  }

  return (
    <Typography variant={variant} {...sharedProps}>
      {children}
    </Typography>
  );
}
